import { SET_HEALTH_TERMS } from "./../../actions/healthInformation/healthInformationActions";

export default function healthInformationReducer(state = {}, action) {
  if (action.type === SET_HEALTH_TERMS) {
    return {
      ...state,
      healthTerms: action.payload
    };
  } else {
    return state;
  }
}
